/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@chakra-ui/react'
import { useState } from 'react'
import { LazyLoadComponent, LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/opacity.css'
import React from 'react'
import { ImageDimensions } from './LazyHelpers'

const LazyLoadComponentSafe = LazyLoadComponent as React.ComponentType<React.PropsWithChildren<Record<string, unknown>>>
const LazyLoadImageSafe = LazyLoadImage as React.ComponentType<React.PropsWithChildren<Record<string, unknown>>>
// import useMobile from "../../hooks/useMobile";

const LazyBox = (props: any) => {
  const { children, src, width, height, isPercentage, ...rest } = props

  const [imageRatio, setImageRatio] = useState(1)

  const boxWidth = width
  const boxHeight = height
  const imageWidth = 1 * imageRatio
  const imageHeight = 1

  const scalingFactor =
    boxWidth / boxHeight > imageWidth / imageHeight ? boxWidth / imageWidth : boxHeight / imageHeight

  const finalWidth = imageRatio * scalingFactor

  const measurements = isPercentage ? '%' : 'px'

  return (
    <>
      <ImageDimensions src={src} setImageRatio={setImageRatio} />

      <LazyLoadComponentSafe {...rest}>
        <Box
          {...rest}
          width={`${width}${measurements}`}
          height={`${height}${measurements}`}
          position="relative"
          p="0"
          // marginLeft={isBigTablet ? "-15px" : "0"}
          overflow={'hidden'}
          zIndex={0}
        >
          {children}

          <LazyLoadImageSafe
            src={src}
            style={{
              position: 'absolute',
              top: '0',
              left: `${(-1 * (finalWidth + (measurements == '%' ? 30 : 0) - boxWidth)) / 2}${measurements}`,
              width: `${finalWidth + (measurements == '%' ? 30 : 0)}${measurements}`,
              maxWidth: `${finalWidth + (measurements == '%' ? 30 : 0)}${measurements}`,
              minWidth: `${finalWidth + (measurements == '%' ? 30 : 0)}${measurements}`,
              transform: 'translate(0%, -15%)', // Centers the image
            }}
            effect="opacity"
          />
        </Box>
      </LazyLoadComponentSafe>
    </>
  )
}

export default LazyBox
